import React from "react";
import "./Banner.css";
const Banner = () => {
  return (
    <div id="home" style={{ backgroundColor: "#333636" }} className="">
      <div className="container py-5 ">
        <div className="row  ">
          <div className="col-sm-12 col-md-4 img-design ">
            <img
              style={{
                marginBottom: "-360px",
                border: "1px solid yellow",
                borderRadius: "5px",
              }}
              className="w-75  "
              src="https://i.ibb.co/Rzw6sNM/Untitled-design-2.jpg"
              alt=""
            />
          </div>
          <div className="col-sm-12 col-md-8 design-text">
            <p className="text-white">HELLOW,</p>
            <h1
              style={{ textAlign: "justify", color: "#ffff" }}
              className="fw-bold text-left"
            >
              {" "}
              I'm{" "}
              <span style={{ color: "orange " }}> Junior Web Devoloper</span>
            </h1>

            <br />
            <p style={{ textAlign: "justify", color: "#ffff" }}>
              I'm from Bangladesh . I want to work in an organization where I
              will learn something new and work with you. Learn something new to
              become a full-stack developer.
            </p>
            <br />

            <a
              href="https://drive.google.com/file/d/1eAiJDo_tjEjudAAEbHUItlP88vPCPrqr/view?usp=sharing"
              target="_blank"
              style={{
                textAlign: "justify",
                color: "#ffff",
                backgroundColor: "orange",
              }}
              type="button"
              className="btn fw-bold  "
            >
              Download Resume{" "}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
